import { render, staticRenderFns } from "./RegrasDescontoManage.vue?vue&type=template&id=1d3dd9dd&scoped=true"
import script from "./RegrasDescontoManage.vue?vue&type=script&lang=js"
export * from "./RegrasDescontoManage.vue?vue&type=script&lang=js"
import style0 from "./RegrasDescontoManage.vue?vue&type=style&index=0&id=1d3dd9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3dd9dd",
  null
  
)

export default component.exports